import { makeAxiosRequest } from 'utils/apiMethods';

interface ChatApi {
  generateQuery: (data: any) => Promise<any>;
}

const chatApi: ChatApi = {
  generateQuery: makeAxiosRequest(
    `${process.env.REACT_APP_API_URL}/ai/generate`,
    { method: 'post' },
    true,
  ),
};

export default chatApi;
